// eslint-disable-next-line @typescript-eslint/no-require-imports
export const faviconPath = require('@ms/yammer-assets/dist/web/ve/favicon.ico');
// eslint-disable-next-line @typescript-eslint/no-require-imports
export const faviconDotPath = require('@ms/yammer-assets/dist/web/ve/faviconDot.ico');
